//A reusable component or widget for dashboard-related UI elements.
import React, { useContext, useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Link } from 'react-router-dom';
import '../App.css'; // Optional styling

const Dashboard = ({ devices }) => {
    const [deviceList, setDeviceList] = useState(devices || []);

   
    useEffect(() => {
        setDeviceList(devices); // Update the state when devices prop changes
    }, [devices]);

    const onDragEnd = (result) => {
        if (!result.destination) return; // If the item was dropped outside of a valid drop area, exit.

        const reorderedDevices = Array.from(deviceList);
        const [movedDevice] = reorderedDevices.splice(result.source.index, 1);
        reorderedDevices.splice(result.destination.index, 0, movedDevice);

        setDeviceList(reorderedDevices);

        // Optionally, save the new order to the backend
        console.log('New device order:', reorderedDevices);
    };

    return (
        <div className="dashboard-container">
           

            {/* Devices Section */}
            <section className="devices-section">
                <h2>Your Devices</h2>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="devices">
                        {(provided) => (
                            <div
                                className="device-grid"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {deviceList.map((device, index) => (
                                    <Draggable
                                        key={device._id}
                                        draggableId={device._id}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <div
                                                className="device-pictogram"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                {/* Updated img tag */}
                                                <img
                                                    src={`/icons/${device.icon}`}
                                                    alt={device.name}
                                                    className="device-icon"
                                                    width={50}
                                                    height={50}
                                                />
                                                <p>{device.name}</p>
                                                <p>{device.type}</p>
                                                <p>
                                                    Latest Data:{' '}
                                                    {device.data?.[0]?.values?.temperature || 'No Data'}
                                                </p>
                                                <Link to={`/device/${device._id}`}>
                                                    View Details
                                                </Link>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </section>
        </div>
    );
};

export default Dashboard;
